module.exports = {"id":"234763","name":"Ramón Folch","rating":"71","photo":"./data/images/photos/3/234763.png","club":{"name":"Real Oviedo","logo":"./data/images/clubs/RealOviedo.png"},"positions":["MC","MDC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/RamonFolch0.json
// module id = 3532
// module chunks = 0